type DocumentDiscountLabelOptions = {
  promotionName?: string | null;
  promotionId?: string | null;
  discountReason?: string | null;
  discountType?: 'PERCENT' | 'FLAT' | null;
  discountValue?: number | null;
};

function promotionNameFromReason(
  promotionId: string | null | undefined,
  discountReason: string | null | undefined,
): string | null {
  if (!promotionId || !discountReason) return null;
  return discountReason.match(/^Promo:\s*(.+?)\s*$/i)?.[1]?.trim() || null;
}

function formatPercent(value: number): string {
  return Number.isInteger(value) ? `${value}%` : `${value.toFixed(2)}%`;
}

export function documentDiscountLabel({
  promotionName,
  promotionId,
  discountReason,
  discountType,
  discountValue,
}: DocumentDiscountLabelOptions): string {
  const resolvedPromotionName =
    promotionName?.trim() || promotionNameFromReason(promotionId, discountReason);
  const label = resolvedPromotionName ? `Promotion: ${resolvedPromotionName}` : 'Discount';
  const value = Number(discountValue) || 0;

  return discountType === 'PERCENT' && value > 0 ? `${label} (${formatPercent(value)})` : label;
}
